import "core-js/stable"
import "regenerator-runtime/runtime"
import React from 'react'
import {render} from 'react-dom'
import {Page} from '../discover'

document.addEventListener("DOMContentLoaded", () => {
  const pageMountpoint = document.getElementById('page-mountpoint')
  const data = pageMountpoint.getAttribute('data-json')
  const page = React.createElement(Page, JSON.parse(data))
  render(page, pageMountpoint)
})
